import { useTranslation } from "react-i18next";

import { ReactComponent as Logo } from "shared/assets/images/logo-strm.svg";
import "./MenuLateral.scss";
import { Link, useHistory } from "react-router-dom";
import { Layout, Menu } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileAlt, faSignOutAlt } from "@fortawesome/free-solid-svg-icons";
import { LanguageChange } from "shared/components";
import { logout } from "shared/helpers/auth-functions";
const { Sider } = Layout;

const MenuLateral = () => {
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <Sider
      collapsible
      trigger={null}
      style={{ minHeight: "100vh" }}
      collapsed={true}
      className="menu"
    >
      <div className="logo">
        <Logo
          style={{ width: 64, cursor: "pointer" }}
          onClick={() => history.push("/")}
        />
      </div>

      <Menu mode="inline" selectedKeys={[history?.location?.pathname]}>
        <Menu.Item
          key="/meus-dados"
          icon={<FontAwesomeIcon icon={faFileAlt} />}
        >
          <Link to="/meus-dados-radar">
            {t("components.MenuLateral.meusDados")}
          </Link>
        </Menu.Item>
        <Menu.Item
          key="9"
          icon={<FontAwesomeIcon icon={faSignOutAlt} />}
          onClick={() => logout(false)}
        >
          {t("components.MenuLateral.sair", "sair")}
        </Menu.Item>
      </Menu>
      <LanguageChange.SelectLanguageChange />

      <div></div>
      <div></div>
    </Sider>
  );
};

export default MenuLateral;
